module.exports = __webpack_public_path__ + "img/afnor.9c1efaef.jpg";